import { useState } from 'react';
import { TURBO_RENT_REPORTING } from 'externals/_tracking/optimizely';
import { useVariationForExperiment } from 'externals/_tracking/optimizely/optimizely.hook';
import { SEEN_OFFER } from 'externals/_tracking/types/eventTypes.constants';

export const useRentPaymentDashboard = (
  userInfo,
  history,
  eventHandler,
  modulePosition = null,
) => {
  const [isSeenTriggered, setIsSeenTriggered] = useState(false);
  const expRentPaymentDashboard =
    useVariationForExperiment(TURBO_RENT_REPORTING);
  const { variation, loading } = expRentPaymentDashboard;
  const isRentReportingIncluded =
    userInfo?.premiumPlanInfo?.rentReportingIncluded;
  const showRentPaymentDashboard = isRentReportingIncluded;

  const onVisibilityChange = isVisible => {
    if (isVisible === true && !isSeenTriggered) {
      eventHandler(SEEN_OFFER, {
        'Product Offer': 'Premium',
        'Page Position': 'Premium',
        'Module Position': modulePosition,
        Vertical: 'Subscription',
        Name: `Rent Payment Dashboard`,
      });
      setIsSeenTriggered(true);
    }
  };

  return {
    experiment: expRentPaymentDashboard,
    showRentPaymentDashboard,
    onVisibilityChange,
    variation,
    loading,
  };
};
